// Does the party fit the chosen car? When it does not, the page suggests the next car that does (Essential -> Signature -> Majestic) instead of just greying things out.
export const fits = (cls, passengers, bags) => !!cls && passengers <= cls.maxPassengers && bags <= cls.maxBags;

// The largest party any car in the list can take (the steppers stop here).
export function maxParty(list) {
  return { passengers: Math.max(1, ...list.map((c) => c.maxPassengers || 0)), bags: Math.max(0, ...list.map((c) => c.maxBags || 0)) };
}

// The next car, in list order after the current one, that takes this party; failing that, any other car that does (a car late in the list can be
// the small one). null when the current car fits or no car does.
export function nextFit(list, currentId, passengers, bags) {
  const i = list.findIndex((c) => c.id === currentId);
  if (i < 0 || fits(list[i], passengers, bags)) return null;
  return list.slice(i + 1).find((c) => fits(c, passengers, bags)) || list.slice(0, i).find((c) => fits(c, passengers, bags)) || null;
}

// "Your bags fit comfortably in Majestic. Switch to Majestic?" (no counts, no price)
export function fitMessage(current, next, passengers, bags) {
  const tooMany = passengers > current.maxPassengers;
  const tooHeavy = bags > current.maxBags;
  const what = tooMany && tooHeavy ? 'Your party and bags fit' : tooMany ? 'Your party fits' : 'Your bags fit';
  return `${what} comfortably in ${next.name}. Switch to ${next.name}?`;
}
